import { GGender, GNumber, GPerson, GTense, TenseCategory, TextWordType, TextWordVerb } from "@model";
import { getLemma } from "./word-tag.helper";

export function getVerbGNumber(tag: string): GNumber {
  if (tag.match("_sg_")) {
    return GNumber.SINGULAR;
  } else if (tag.match("_pl_")) {
    return GNumber.PLURAL;
  } else if (tag.match("_inf_")) {
    return GNumber.NULL;
  } else {
    console.log("!!!!! wrong grammatical number for verb ", tag);
    return GNumber.NULL;
  }
}

export function getVerbGGender(tag: string): GGender {
  if (tag.match("_m_")) {
    return GGender.M;
  } else if (tag.match("_f_")) {
    return GGender.F;
  } else if (tag.match("_n_")) {
    return GGender.N;
  } else if (tag.match("_f_n_")) {
    return GGender.F_N;
  } else if (tag.match("_inf_") || tag.match("fin_")) {
    return GGender.NULL;
  } else {
    console.log("!!!!! wrong grammatical gender for verb ", tag);
    return GGender.NULL;
  }
}

export function getVerbGTense(tag: string): GTense {
  if (tag.match("fin_imperf")) {
    return GTense.PRESENT;
  } else if (tag.match("fin_perf")) {
    return GTense.FUTURE;
  } else if (tag.match("inf_perf")) {
    return GTense.INF;
  } else if (tag.match("inf_imperf")) {
    return GTense.INF_PERFECT;
  } else if (tag.match("imperf")) {
    return GTense.PAST_IMPERFECT;
  } else if (tag.match("perf")) {
    return GTense.PAST_PERFECT;
  } else {
    console.log("!!!!! wrong grammatical tense", tag);
    return GTense.INF;
  }
}

export function getVerbTenseCategory(tag: string): TenseCategory {
  if (tag.match("fin_imperf")) {
    return TenseCategory.PRESENT;
  } else if (tag.match("fin_perf")) {
    return TenseCategory.FUTURE;
  } else if (tag.match("inf_perf") || tag.match("inf_imperf")) {
    return TenseCategory.INF;
  } else if (tag.match("imperf") || tag.match("perf")) {
    return TenseCategory.PAST;
  } else {
    console.log("!!!!! wrong tense category", tag);
    return TenseCategory.INF;
  }
}

export function getVerbGPerson(tag: string): GPerson {
  if (tag.match("_pri_")) {
    return GPerson.PRI;
  } else if (tag.match("_sec_")) {
    return GPerson.SEC;
  } else if (tag.match("_ter_")) {
    return GPerson.TER;
  } else {
    console.log("!!!!! wrong peron", tag);
    return GPerson.PRI;
  }
}

export function findPropertiesForVerb(tag: string): TextWordVerb {
  // v__perf_sg_f_ter__otwierać_otworzyła
  const [, core] = tag.split("__");

  return {
    gCore: core,
    wordType: TextWordType.VERB,
    lemma: getLemma(tag),
    tense: getVerbGTense(tag),
    tenseCategory: getVerbTenseCategory(tag),
    gNumber: getVerbGNumber(tag),
    gGender: getVerbGGender(tag),
    person: getVerbGPerson(tag)
  };
}
